import Swiper from 'swiper'
import 'swiper/css'

class BlogSwiper {
    constructor(swiper) {
        this.swiper = swiper
        this.swiperID = swiper.dataset.id

        this.initSwiper()     
    }

    initSwiper() {
        const swiper = new Swiper('[data-id="' + this.swiperID + '"]', {
            slidesPerView: 1.1,
            spaceBetween: 20,
            loop: true,
            breakpoints: {
                560: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3.2
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 0
                },
            },
            on: {
                resize: function () {
                    if (window.matchMedia('(min-width: 1024px)').matches) {
                        swiper.disable()
                    } else {
                        swiper.enable()
                    }
                }
            }
        })
    }
}

window.addEventListener('DOMContentLoaded', function () {
    const swipers = this.document.querySelectorAll('.o-blog-swiper')

    swipers.forEach(swiper => {
        new BlogSwiper(swiper)
    });
})
